var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix\"><span ng-transclude=\"label\" class=\"pull-left {{::$ctrl.labelClass}}\"><span class=\"text-{{::$ctrl.labelColor || 'muted'}}\">{{::$ctrl.label}}</span> </span><span class=\"pull-right text-right\"><span ng-transclude=\"\" class=\"{{::$ctrl.valueClass}}\"><span class=\"text-{{::$ctrl.valueColor || 'default'}}\">{{$ctrl.value}}</span> </span><span ng-transclude=\"value\" class=\"{{::$ctrl.valueClass}}\"></span></span></div>";
var id1="datum-split.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;